<template>
    <div class="tabs">
        <height-transition v-show="showTabs">
            <ul :class="['tabs-menu', tabsMenuClass]" role="tablist">
                <li v-for="tab in tabs"
                    :class="{ 'is-active': tab.isActive }"
                    class="tabs-menu-item"
                    role="presentation"
                    :key="tab.hash"
                >

                    <a v-html="tab.name"
                    :aria-controls="tab.hash"
                    :aria-selected="tab.isActive"
                    @click.prevent="selectTab(tab.hash)"
                    :href="tab.hash"
                    class="link"
                    role="tab"
                    ></a>

                </li>

                <li :class="['tabs-menu-item', 'more', {'is-active': moreHasActive}]" v-show="moreVisible">
                    <dropdown align="top right no-gap">
                        <a slot="toggle" href="#" class="link">{{ $t__('More') }}</a>
                        <ul class="more-list"></ul>
                    </dropdown>
                </li>
            </ul>
        </height-transition>

        <div class="tabs-panels">
            <slot/>
        </div>
    </div>
</template>

<script>
    import Dropdown from './Dropdown';
    import LocalStorage from './../support/LocalStorage';

    export default {
        name: 'Tabs',

        components: { Dropdown },

        props: {
            horizontal: {
                type: Boolean,
                default: true
            },
            tabsMenuClass: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                default: ''
            },
            rememberActive: {
                type: Boolean,
                default: false
            },
            activeTab: {
                type: String,
                default: ''
            },
            showTabs: {
                type: Boolean,
                default: true
            }
        },

        data: () => ({
            tabs: [],
            children: [],
            activeTabHash: '',
            tabsMenu: [],
            moreBurger: {},
            moreList: {},
            moreVisible: true,
            moreHasActive: false,
            rendered: false
        }),

        created() {

        },

        watch: {
            activeTabHash(value) {
                LocalStorage.set('activeTabHash', value);
                this.$emit('changed-tab', value);
            }
        },

        mounted() {
            !this.rememberActive ? LocalStorage.disable() : LocalStorage.namespace(`tabs.${this.id}`);

            this.tabs = this.$children.filter(child => child.$options.name == 'tabs-item');

            this.list = this.$el.querySelector('.tabs-menu');
            this.moreBurger = this.list.querySelector('.tabs-menu-item.more');
            this.moreList = this.moreBurger.querySelector('.more-list');

            var rememberedHash = LocalStorage.get('activeTabHash');
            this.selectTab(rememberedHash && this.findTab(rememberedHash) ? rememberedHash : (this.activeTab ? `#${this.activeTab}` : this.tabs[0].hash));

            window.addEventListener('resize', this.updateMoreList);
        },

        updated() {
            if (this.tabs.length) {
                this.tabsMenu = this.$el.querySelectorAll('.tabs-menu > .tabs-menu-item:not(.more)');
                if (this.tabsMenu && this.tabsMenu.length == this.tabs.length && this.rendered == false) {
                    this.updateMoreList();
                }
            }
        },

        methods: {
            findTab(hash) {
                return this.tabs.find(tab => tab.hash === hash);
            },

            selectTab(selectedTabHash) {
                const selectedTab = this.findTab(selectedTabHash);

                if (!selectedTab) {
                    return;
                }

                for (var i = 0; i < this.tabs.length; i++) {
                    var tab = this.tabs[i];
                    tab.isActive = (tab.hash === selectedTab.hash);
                }

                this.activeTabHash = selectedTab.hash;

                this.moreHasActive = this.moreList.querySelectorAll('[href="' + this.activeTabHash + '"]').length ? true : false;
            },

            updateMoreList() {
                let navWidth = 0;
                const moreWidth = this.moreBurger.offsetWidth;
                this.tabsMenu = this.$el.querySelectorAll('.tabs-menu > .tabs-menu-item:not(.more)');

                for (var i = 0; i < this.tabsMenu.length; i++) {
                    var tab = this.tabsMenu[i];
                    navWidth += tab.offsetWidth;
                }

                const tabsMenuStyles = window.getComputedStyle(this.$el.querySelector('.tabs-menu'));
                const availableSpace = this.$el.offsetWidth - moreWidth - parseInt(tabsMenuStyles.getPropertyValue('padding-left')) - parseInt(tabsMenuStyles.getPropertyValue('padding-right')) - 10;

                if (availableSpace <= 0 && !this.rendered) {
                    this.$nextTick(() => {
                        this.updateMoreList();
                    });

                    return;
                }

                if (navWidth > availableSpace) {
                    let $lastItem = this.moreBurger.previousElementSibling;

                    if ($lastItem) {
                        $lastItem.setAttribute('data-width', $lastItem.offsetWidth);

                        let $insertReference = this.moreList.firstChild ? this.moreList.firstChild : null;
                        this.moreList.insertBefore($lastItem, $insertReference);

                        this.updateMoreList();
                    }
                } else {
                    let $firstMoreItem = this.moreList.firstChild;

                    if ($firstMoreItem) {
                        if (navWidth + parseInt($firstMoreItem.getAttribute('data-width')) < availableSpace) {
                            this.list.insertBefore($firstMoreItem, this.moreBurger);
                        }
                    }
                }

                this.rendered = true;
                this.moreVisible = (this.moreList.querySelectorAll('li').length > 0);
            },
        },
    };
</script>
